<template>
  <div>
    <loading v-if="loading" id="loading"></loading>

    <div id="error" class="q-pa-md row items-start q-gutter-md" v-if="!loading && error !== null">
      <q-card>
        <q-card-section>
          <img src="@/assets/brands/logo-small.png" alt=""/>
        </q-card-section>
        <q-card-section>
          <h3>ERROR!</h3>
          <p>{{ error }}</p>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col text-right mr1">
              <q-btn color="primary" label="Try again" class="btn"
                     @click.prevent="getInvoice($route.params.id)"></q-btn>
            </div>
            <div class="col text-left ml1">
              <q-btn color="secondary" label="Go Home" class="btn" @click.prevent="$router.push('/')"></q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </div>

    <div id="invoice" class="q-pa-md row items-start q-gutter-md" v-if="!loading && invoice">
      <q-card>
        <q-card-section class="header">
          <div class="row">
            <div class="col col-12 col-md-4">
              <img src="@/assets/brands/logo-small.png" alt=""/>
            </div>
            <div class="col col-12 col-md-8">
              <h1 class="invoice-title">Invoice #{{ $route.params.id }}</h1>
            </div>
          </div>
        </q-card-section>
        <q-card-section class="content">
          <div class="row">
            <div class="col">
              <h2 class="company-title">Company: {{ invoice.company.name }}</h2>
              <div v-if="invoice.description !== null || invoice.description !== ''">
                <p v-html="invoice.description"></p>
              </div>
            </div>
            <div class="col">
              <div class="payment text-right">
                <q-btn :disable="paymentLoading" :loading="paymentLoading" label="Secure Payment" color="secondary"
                       class="btn" @click.prevent="paymentWithStripe()" v-if="invoice.paid_at === null"/>
                <q-chip square color="green" text-color="white" v-else>Paid</q-chip>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <table class="table">
                <tbody>
                <tr>
                  <th>ID:</th>
                  <td>{{ invoice.id }}</td>
                </tr>
                <tr>
                  <th>Amount:</th>
                  <td>${{ invoice.amount }}</td>
                </tr>
                <tr>
                  <th>Period:</th>
                  <td>{{ invoice.months }} month<span v-if="invoice.months > 1">s</span></td>
                </tr>
                <tr>
                  <th>Status:</th>
                  <td>
                    <q-chip square color="red" text-color="white" label="Unpaid" v-if="invoice.paid_at === null"/>
                    <q-chip square color="green" text-color="white" v-else>
                      Paid: {{ invoice.paid_at | dateTimeFormat }}
                    </q-chip>
                  </td>
                </tr>
                <tr>
                  <th>Created at:</th>
                  <td>{{ invoice.created_at | dateTimeFormat }}</td>
                </tr>
                <tr>
                  <th>Due date:</th>
                  <td>{{ invoice.created_at | dateFormat }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </q-card-section>
        <q-card-actions class="footer justify-center" v-if="isAuthorized">
          <q-btn label="Go to invoices" color="primary" class="btn" @click.prevent="$router.push('/invoices')"/>
        </q-card-actions>
      </q-card>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import Loading from "@/components/Loading.vue";

export default {
  name: "invoice",
  components: {Loading},
  data() {
    return {
      isAuthorized: false,
      error: null,
      loading: true,
      paymentLoading: false,
      invoice: null,
    }
  },
  methods: {
    async checkIsAuthorized() {
      this.isAuthorized = localStorage.getItem('token') !== null;
    },
    async getInvoice(id) {
      try {
        this.loading = true;
        const {data} = await axios.get(`invoice/${id}`);
        this.invoice = data.data;
      } catch (e) {
        this.error = e.response.data.message;
      } finally {
        this.loading = false;
      }
    },
    async paymentWithStripe() {
      try {
        this.paymentLoading = true;
        const {data} = await axios.get(`invoice/${this.invoice.id}/payment/stripe`);
        window.location.href = data.data.url;
      } catch (e) {
        this.paymentLoading = false;
        this.$q.notify({
          type: 'negative',
          position: 'top',
          progress: true,
          message: e.response.data.message,
        });
      }
    },
    async redirectInvoice() {
      await this.$router.push(`/invoice/${this.invoice.id}`);
    },
    async cancel() {
      try {
        this.paymentLoading = true;
        await axios.get(`invoice/${this.invoice.id}/transaction/${this.$route.query.transaction}/cancel`);
        this.$q.notify({
          type: 'positive',
          position: 'top',
          progress: true,
          message: 'Payment canceled',
        });
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          progress: true,
          message: e.response.data.message,
        });
      } finally {
        this.paymentLoading = false;
        await this.redirectInvoice();
      }
    },
    async results() {
      if (!this.$route.query.transaction) {
        return;
      }

      if (this.$route.query.status === 'success') {
        this.$q.notify({
          type: 'positive',
          position: 'top',
          progress: true,
          message: 'Payment successful',
        });
        this.paymentLoading = true;
        setTimeout(async () => {
          await this.redirectInvoice();
        }, 2000);
      } else if (this.$route.query.status === 'cancel') {
        await this.cancel();
      }
    },
  },
  async mounted() {
    await this.checkIsAuthorized();
    await this.getInvoice(this.$route.params.id);
    await this.results();
  }
}
</script>

<style scoped lang="scss">
#loading {
  background-color: transparent !important;
}

#error {
  position: relative;
  display: block;
  margin: auto;
  width: 100%;
  max-width: 480px;
  text-align: center;

  h3 {
    margin: 0 15px 0;
    font-size: 20px;
    font-weight: bold;
    color: red;
  }

  .btn {
    margin: 0 5px;
  }
}

#invoice {
  position: relative;
  display: block;
  margin: auto;
  width: 100%;
  max-width: 720px;
  height: 100%;

  .header {
    border-bottom: 1px solid #d5d5d5;

    h1.invoice-title {
      margin: 0;
      padding: 0;
      text-align: right;
      font-size: 18px;
      line-height: 40px;
      font-weight: 500;
    }
  }

  .content {
    h2.company-title {
      margin: 0;
      padding: 0;
      font-size: 18px;
      line-height: 40px;
      font-weight: 500;
    }

    table.table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #f2f2f2;

      th, td {
        padding: 10px;
        border: 1px solid #f2f2f2;
        cursor: default;
      }

      th {
        width: 30%;
        text-align: right !important;
      }

      td {
        width: 70%;
        text-align: left !important;
      }
    }
  }

  .footer {
    border-top: 1px solid #d5d5d5;
  }
}
</style>
